/* FILLIN OXFORD LP — behaviour (no dependencies) */
(function () {
  'use strict';
  var root = document.getElementById('lpox');
  if (!root) return;
  document.documentElement.classList.add('lpox-js');

  /* ---------- 1. LINE CTA links ---------- */
  var cfg = window.LPOX || {};
  var lineUrl = cfg.lineUrl || '';
  var ctas = root.querySelectorAll('[data-lpox-line]');
  ctas.forEach(function (a) {
    if (lineUrl) {
      a.setAttribute('href', lineUrl);
    } else {
      a.setAttribute('href', '#');
      a.addEventListener('click', function (e) { e.preventDefault(); });
    }
    a.addEventListener('click', function () {
      var pos = a.getAttribute('data-lpox-pos') || 'cta';
      try {
        if (typeof window.fbq === 'function' && cfg.fbEvent) {
          window.fbq('track', cfg.fbEvent, { content_name: 'oxford_lp_line', content_category: pos });
        }
      } catch (err) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lpox_line_click', lpox_position: pos });
      } catch (err) {}
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('lpox_line_click', { position: pos });
        }
      } catch (err) {}
    });
  });

  /* ---------- 2. Sliders (scroll-snap + dots) ---------- */
  root.querySelectorAll('[data-lpox-slider]').forEach(function (slider) {
    var track = slider.querySelector('.lpox-slider__track');
    var slides = track ? track.querySelectorAll('.lpox-slider__slide') : [];
    var dotsWrap = slider.querySelector('.lpox-slider__dots');
    if (!track || !slides.length || !dotsWrap) return;
    dotsWrap.innerHTML = '';
    var dots = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lpox-slider__dot';
      b.setAttribute('aria-label', (i + 1) + '枚目を表示');
      b.addEventListener('click', function () {
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
    var current = -1;
    function update() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (track.scrollLeft < 4) best = 0;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = slides.length - 1;
      if (best === current) return;
      current = best;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- 3. Reveal on scroll ---------- */
  /* Auto-apply the recap fade-up to the top-level blocks of every section
     (lists are split into their items so cards rise one by one).
     Skips FV/header/footer, decorations, absolutely positioned or already
     transformed elements, and blocks that carry hand-placed .lpox-reveal. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    var skipSection = /lpox-s--(header|fv|footer)\b/;
    var canReveal = function (el) {
      if (el.matches('script, style, template, [aria-hidden="true"], [data-lpox-fixed]')) return false;
      if (el.classList.contains('lpox-reveal') || el.querySelector('.lpox-reveal')) return false;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || /absolute|fixed|sticky/.test(cs.position) || cs.transform !== 'none') return false;
      return el.offsetHeight > 0;
    };
    root.querySelectorAll('.lpox-s').forEach(function (sec) {
      if (skipSection.test(sec.className)) return;
      var inner = sec.firstElementChild;
      if (!inner) return;
      Array.prototype.forEach.call(inner.children, function (el) {
        if (/^(UL|OL)$/.test(el.tagName) && el.children.length > 1 && !el.querySelector('.lpox-reveal')) {
          Array.prototype.forEach.call(el.children, function (li) {
            if (canReveal(li)) li.classList.add('lpox-reveal', 'lpox-reveal--auto');
          });
        } else if (canReveal(el)) {
          el.classList.add('lpox-reveal', 'lpox-reveal--auto');
        }
      });
    });
  }

  var reveals = root.querySelectorAll('.lpox-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      var step = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        // blocks entering together rise in sequence (max 4 steps)
        el.style.transitionDelay = (Math.min(step++, 4) * 0.18) + 's';
        el.classList.add('is-in');
        io.unobserve(el);
        if (el.classList.contains('lpox-reveal--auto')) {
          // hand the element back to its own styles once it has settled
          var done = function () {
            el.classList.remove('lpox-reveal', 'lpox-reveal--auto', 'is-in');
            el.style.transitionDelay = '';
          };
          el.addEventListener('transitionend', function te(e) {
            if (e.target === el && e.propertyName === 'opacity') { el.removeEventListener('transitionend', te); done(); }
          });
          setTimeout(done, 3500);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- 4. Fixed CTA: show after FV, hide while another CTA is on screen ---------- */
  var fixed = document.querySelector('[data-lpox-fixed]');
  if (fixed && 'IntersectionObserver' in window) {
    var fv = root.querySelector('[data-lpox-fv]');
    var pastFv = !fv;
    var visibleCtas = new Set();
    function sync() { fixed.classList.toggle('is-show', pastFv && visibleCtas.size === 0); }
    if (fv) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          pastFv = !en.isIntersecting && en.boundingClientRect.top < 0;
        });
        sync();
      }).observe(fv);
    }
    var ctaIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visibleCtas.add(en.target); else visibleCtas.delete(en.target);
      });
      sync();
    });
    root.querySelectorAll('.lpox-cta').forEach(function (c) { if (!fixed.contains(c)) ctaIo.observe(c); });
    sync();
  }
})();
